import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { ChartColumnDecreasing } from 'lucide-react'
import moment from 'moment';
import queryString from 'query-string';
import { DefaultTooltip } from 'twyne-new.ui'

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function ReportLink({ info }) {
  const { row } = getInfo(info)
  const { id } = row

  const search = useMemo(() => {
    const date = moment().format('MM-DD-YYYY')
    return queryString.stringify({
      filterby: JSON.stringify({ page: [id] }),
      metrics: ['totalPC', 'uniqUser', 'revenue', 'rpu', 'uniqUserSession', 'rps', 'rpus', 'rpi'],
      groupby: ['page'],
      sortby: ['hour:nested'],
      startDate: date,
      endDate: date,
    })
  }, [id])

  return <>
    <DefaultTooltip content='Show page report'>
      <Link id={`page-${id}`} className='action' to={{ pathname: '/reports/impression', search }}>
        <ChartColumnDecreasing size={16} />
      </Link>
    </DefaultTooltip>
  </>
}
